import { useState } from 'react';
import { cn } from '../../../lib/cn';
import { Field } from '../../../ui/Field';
import { Textarea } from '../../../ui/Input';
import { Markdown } from '../../../ui/Markdown';
import { Segmented } from '../../../ui/Segmented';

type Mode = 'edit' | 'preview';

/**
 * Edytor Markdown bez ciężkich bibliotek: pole tekstowe + podgląd (ten sam komponent `Markdown` co w notatce,
 * z sanitizacją). Przełącznik „Edycja / Podgląd” przy etykiecie pola.
 */
export function NoteEditor({
  value,
  onChange,
  label = 'Treść',
  hint = 'Markdown: **pogrubienie**, - lista, ## nagłówek, [link](https://…)',
  error,
  rows = 12,
  placeholder,
  id,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  hint?: string | null;
  error?: string | null;
  rows?: number;
  placeholder?: string;
  id?: string;
  className?: string;
}) {
  const [mode, setMode] = useState<Mode>('edit');
  return (
    <Field
      id={id}
      label={label}
      hint={mode === 'edit' ? (hint ?? undefined) : undefined}
      error={error}
      className={className}
      labelAction={
        <Segmented
          aria-label={`${label}: tryb`}
          size="s"
          value={mode}
          onValueChange={setMode}
          options={[
            { value: 'edit', label: 'Edycja' },
            { value: 'preview', label: 'Podgląd' },
          ]}
        />
      }
    >
      {mode === 'edit' ? (
        <Textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          rows={rows}
          placeholder={placeholder}
          className="font-mono text-[13px]"
        />
      ) : (
        <div
          className={cn('min-h-32 rounded-md border border-line px-3 py-2.5', !value.trim() && 'text-fg-muted')}
          aria-live="polite"
        >
          {value.trim() ? <Markdown>{value}</Markdown> : <p className="text-body-s">Nic do podglądu.</p>}
        </div>
      )}
    </Field>
  );
}
